import { createContext, useContext, useState, useRef } from "react";
import { useBlocker } from "react-router-dom";

const UnsavedChangesContext = createContext();

export const UnsavedChangesProvider = ({ children }) => {
  const [showDialog, setShowDialog] = useState(false);
  const targetPathRef = useRef(null);
  const allowActionRef = useRef(false);
  const pendingActionRef = useRef(null);

  const value = {
    showDialog,
    setShowDialog,
    targetPathRef,
    allowActionRef,
    pendingActionRef,
  };

  return (
    <UnsavedChangesContext.Provider value={value}>
      {children}
    </UnsavedChangesContext.Provider>
  );
};

export const useUnsavedChanges = () => {
  const context = useContext(UnsavedChangesContext);
  if (!context) {
    throw new Error(
      "useUnsavedChanges must be used within UnsavedChangesProvider",
    );
  }
  return context;
};

export const useUnsavedChangesBlocker = (hasChanges) => {
  const { setShowDialog, targetPathRef, allowActionRef } = useUnsavedChanges();

  useBlocker(({ _, nextLocation }) => {
    if (allowActionRef.current) {
      allowActionRef.current = false;
      return false;
    }
    if (hasChanges) {
      targetPathRef.current = nextLocation.pathname + nextLocation.search;
      setShowDialog(true);
      return true;
    }
    return false;
  });
};
